<template>
  <ClientTransactionCard v-if="client" embed></ClientTransactionCard>
</template>

<script>
  import ClientTransactionCard from '@/components/ClientTransactionCard'
  import client from '@/mixins/client'

  export default {
    name: 'ClientTransactionEmbed',
    components: {
      ClientTransactionCard
    },
    mixins: [client]
  }
</script>
